import React, { useState, useEffect } from 'react';
import axios from 'axios';
import HomeCarousel from '../components/HomeCarousel';
import './Home.css';

const Home = () => {
  const [carouselItems, setCarouselItems] = useState([]);

  useEffect(() => {
    axios.get('/api/home-carousel')
      .then((res) => setCarouselItems(Array.isArray(res.data) ? res.data : []))
      .catch(() => {});
  }, []);

  return (
    <div className="home-container fade-in">
      <div className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="gradient-text">欢迎来到机械宝宝AI</span>
          </h1>
          <p className="hero-subtitle">专业的AI技术分享与学习平台</p>
          <div className="hero-decoration">
            <div className="floating-element"></div>
            <div className="floating-element"></div>
            <div className="floating-element"></div>
          </div>
        </div>
      </div>

      <HomeCarousel items={carouselItems} defaultInterval={5} />

      <div className="content-section">
        <div className="quick-links">
          <a href="/ai-launcher" className="quick-link-card">
            <div className="quick-link-icon">🚀</div>
            <h3>AI创作助手</h3>
            <p>官方AI客户端、环境与模型资源</p>
          </a>
          <a href="/downloads" className="quick-link-card">
            <div className="quick-link-icon">📦</div>
            <h3>资源中心</h3>
            <p>下载AI整合包和工具</p>
          </a>
          <a href="/community" className="quick-link-card">
            <div className="quick-link-icon">🌐</div>
            <h3>开源社区</h3>
            <p>加入我们的开源社区</p>
          </a>
          <a href="/tutorials" className="quick-link-card">
            <div className="quick-link-icon">🎓</div>
            <h3>视频教程</h3>
            <p>查看最新的AI技术教程</p>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Home;

